























import { Vue, Component, Prop } from 'vue-property-decorator';
import { getIdFromUrl, Youtube } from 'vue-youtube';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Typography,
    Youtube
  }
})
export default class CoinNetworkConcept extends Vue {
  $refs!: {
    youtube: HTMLFormElement;
  };

  link: string = 'https://youtu.be/E7VaLrxOOKI';

  get videoId() {
    return getIdFromUrl(this.link);
  }

  get youtubePlayer() {
    if (!this.$refs.youtube) return {};
    return this.$refs.youtube.player;
  }

  get tPrefix() {
    return 'modals.billing.acceptance.concept';
  }
}
